import axios from 'axios'

export default {
    namespaced: true,
    state: {
        applications: [],
        applicationAttachments: [],
    },
    mutations: {
        SET_APPLICATIONS(state, payload) {
            state.applications = payload;
        },
        SET_APPLICATION_ATTACHMENTS(state, payload) {
            state.applicationAttachments = payload;
        },
    },
    actions: {
        async FetchApplications({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/applications/list`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_APPLICATIONS', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchApplications: ${error.message}`));
            });
        },
        async FetchApplicationAttachmentsByAcademicSession({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/attachments/fetch/academic-session`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_APPLICATION_ATTACHMENTS', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchApplicationAttachments: ${error.message}`));
            });
        },
    },
    getters: {
        Applications(state) { return state.applications; },
        ApplicationAttachments(state) { return state.applicationAttachments; },
    }
};
